/** Israeli ID / company number check digit (same algorithm as the server). */
export function isValidIsraeliId(value: string): boolean {
  const d = value.replace(/\D/g, '');
  if (d.length < 5 || d.length > 9) return false;
  const p = d.padStart(9, '0');
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    let n = Number(p[i]) * ((i % 2) + 1);
    if (n > 9) n -= 9;
    sum += n;
  }
  return sum % 10 === 0;
}

export const isEmail = (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());
